import PropTypes from 'prop-types';
import useBrandFonts from '../../hooks/useBrandFonts';

/**
 * Applies the event's brand fonts to the gallery (PB-10474, LG-01). It renders nothing, so the gallery's DOM is the
 * same with or without brand fonts. `Event` is a class component, so the hook lives here.
 */
const BrandFonts = ({ brandFonts }) => {
  useBrandFonts(brandFonts);
  return null;
};

const fontFamilyShape = PropTypes.shape({
  family: PropTypes.string,
  source: PropTypes.string,
  regularUrl: PropTypes.string,
  boldUrl: PropTypes.string,
});

BrandFonts.propTypes = {
  brandFonts: PropTypes.shape({
    heading: fontFamilyShape,
    body: fontFamilyShape,
  }),
};

BrandFonts.defaultProps = {
  brandFonts: null,
};

export default BrandFonts;
